import { Input, StyleProps } from "@chakra-ui/react";
import { ControlInputFieldProps, TextInputFieldProps } from "components/Form/typings";
import { toTimeWithoutSeconds, toTimeWithSeconds } from "helpers/trigger";
import { useController, useWatch } from "react-hook-form";
import FormField from "./FormField";

export default function TimePickerField({
  control,
  name,
  label,
  errors,
  placeholder,
  helperText,
  required,
  textTransform,
  defaultValue,
  variant,
  formFieldProps = {},
  sx,
  onTimeChange,
  ...props
}: ControlInputFieldProps &
  Pick<TextInputFieldProps, "textTransform"> & { sx: StyleProps; onTimeChange?: (value: string) => void }) {
  const {
    field: { name: fieldName, onChange, onBlur, ref },
  } = useController({
    name,
    control,
    rules: { required },
    ...(defaultValue ? { defaultValue } : {}),
  });

  // Derive the display value (without seconds) from the watched form value
  const watchedValue = useWatch({ control, name });
  const time = watchedValue ? toTimeWithoutSeconds(watchedValue) : "";

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedValue = toTimeWithSeconds(e.target.value);
    onChange(formattedValue);
    onTimeChange?.(formattedValue);
  };

  const formVariant = variant;

  return (
    <FormField
      name={name}
      label={label}
      errors={errors}
      helperText={helperText}
      required={required}
      variant={formVariant}
      {...formFieldProps}
    >
      <Input
        textTransform={textTransform}
        type="time"
        aria-label={`Select time for ${label}`}
        placeholder={formVariant === "floating" ? " " : placeholder}
        _hover={{
          cursor: "pointer",
        }}
        {...props}
        {...sx}
        {...{
          name: fieldName,
          onChange: handleChange,
          onBlur,
          ref,
          value: time,
        }}
      />
    </FormField>
  );
}
